module.exports = __webpack_public_path__ + "img/missionEnd-1.fb893572.jpg";